import { inject } from 'vue';

export function useTypeChecker() {
  const { testWorkQueueTypes } = inject('constants');

  const extractSlug = (item) => {
    return item && typeof item === 'object' ? item.slug : item;
  };

  const isValidType = (types, typeSlug) => {
    if (!Array.isArray(types)) return false;
    return types.some(type => extractSlug(type) === typeSlug);
  };

  function hasRemotePrintingType(types) {
    return isValidType(types, testWorkQueueTypes.REMOTE_PRINTING);
  }

  function hasIsoSkippedType(types) {
    return isValidType(types, testWorkQueueTypes.ISO_SKIPPED);
  }

  function hasAutomaticDesignType(types) {
    return isValidType(types, testWorkQueueTypes.AUTOMATIC_DESIGN);
  }

  return { 
    hasRemotePrintingType, 
    hasIsoSkippedType, 
    hasAutomaticDesignType,
    extractSlug 
  };
}
